export enum CustomPropertyDataType
{
    STRING,
    INT,
    BOOL,
    LIST,
    DATE,
    TIME
}

export const CustomPropertyDataType_LABELS =
{
    STRING: "String",
    INT: "Number",
    BOOL: "True/False",
    LIST: "List",
    DATE: "Date",
    TIME: "Time",
}

export const CustomPropertyListPresentation_LABELS =
{
    LIST: "List",
    LOOKUP: "Lookup"
}
